import P from 'prop-types';
import { useRef } from 'react';
// import { useState } from 'react';

// eslint-disable-next-line no-unused-vars
export const Notification = ({ time, text, delay }) => {
  const classe = useRef();

  const handleClickClose = () => {
    classe.current.classList.remove('show');
  };

  return (
    <div
      id={'liveToast' + delay}
      className={`toast show`}
      ref={classe}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ border: '1px solid #046931' }}
      data-aos-delay={delay}
      data-aos="fade-up"
    >
      <div className="toast-header">
        <img src="./logo192.png" className="rounded me-2" alt="..." style={{ width: '1.4rem' }} />
        <strong className="me-auto">Canhoto Digital</strong>
        <small>{time}</small>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
          onClick={handleClickClose}
        ></button>
      </div>
      <div className="toast-body">{text}</div>
    </div>
  );
};

Notification.propTypes = {
  text: P.string.isRequired,
  time: P.string.isRequired,
  delay: P.string.isRequired,
};
